import React from 'react'
import { Card, CardHeader, CardTitle, CardDescription, CardContent, StatCard } from '../components/ui/Card'
import { BarChart3, TrendingUp, Users, Activity } from 'lucide-react'

export default function Reports() {
  return (
    <div className="h-full flex flex-col overflow-hidden bg-slate-50">
      {/* Header */}
      <div className="flex-shrink-0 bg-white border-b border-slate-200">
        <div className="max-w-[1800px] mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-emerald-50 flex items-center justify-center">
                <BarChart3 className="h-5 w-5 text-emerald-600" />
              </div>
              <div>
                <h2 className="text-lg font-semibold text-slate-900">Reports</h2>
                <p className="text-sm text-slate-500">View analytics and reports for your customers</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto p-6">
        <div className="max-w-[1800px] mx-auto space-y-6">

        {/* Placeholder Metrics */}
        <div className="grid metrics-grid metrics-grid-4">
          <StatCard
            title="Total Reports"
            value="—"
            description="Coming soon"
            icon={<BarChart3 className="h-5 w-5 text-orange-600" />}
            color="orange"
          />
          <StatCard
            title="Insights"
            value="—"
            description="Coming soon"
            icon={<TrendingUp className="h-5 w-5 text-emerald-600" />}
            color="emerald"
          />
          <StatCard
            title="Active Users"
            value="—"
            description="Coming soon"
            icon={<Users className="h-5 w-5 text-blue-600" />}
            color="blue"
          />
          <StatCard
            title="Activity"
            value="—"
            description="Coming soon"
            icon={<Activity className="h-5 w-5 text-amber-600" />}
            color="amber"
          />
        </div>

        {/* Main Content */}
        <Card>
          <CardHeader>
            <CardTitle size="lg">Reports & Analytics</CardTitle>
            <CardDescription>Detailed reports and analytics coming soon</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="text-center py-16">
              <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-orange-100 to-amber-100 flex items-center justify-center mx-auto mb-6">
                <BarChart3 className="h-8 w-8 text-orange-600" />
              </div>
              <h3 className="text-lg font-semibold text-slate-900 mb-2">Reports Coming Soon</h3>
              <p className="text-sm text-slate-500 max-w-md mx-auto">
                We're working on comprehensive analytics and reporting features to help you 
                better understand your customers' usage and trends.
              </p>
            </div>
          </CardContent>
        </Card>
        </div>
      </div>
    </div>
  )
}
